/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2024-07-01 10:03:23
 * @LastEditTime: 2024-07-01 10:30:09
 */

import goldFlower from '../../images/icon/price_1.png';
import blueFlower from '../../images/icon/price_2.png';

export interface FlowerProps {
  title: string;
  type: 'gold' | 'blue';
}

const PriceFlower = (props: FlowerProps) => {
  return (
    <div className='price-flower-container'>
      <span>{props.title}</span>
      <img src={props.type === 'gold' ? goldFlower : blueFlower} />
    </div>
  );
};

export default PriceFlower;
